import isString from 'lodash.isstring';
import { ErrorResponse } from 'services/connectivity/types';

const unexpectedError = 'Unexpected error occured.';

export function errorDeserialize(error?: ErrorResponse | string): string {
  if (!error) {
    return unexpectedError;
  }

  if (isString(error)) {
    return error;
  }

  return error.error || error.error_description || error.sub_error || unexpectedError;
}
